import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPipeProviders'
})
export class FilterPipeProvider implements PipeTransform {
    transform(providers: any, term?: any): any {
        if (term === undefined) return providers;
        if (term === null) return providers;

        if (providers != null) {
            return providers.filter(function (provider) {
                if (provider.name != undefined)
                    if (provider.name.toString().toLowerCase().includes(term.toLowerCase()))
                        return provider;
                if (provider.nif != undefined)
                    if (provider.nif.toString().toLowerCase().includes(term.toLowerCase()))
                        return provider;
                if (provider.contact_name != undefined)
                    if (provider.contact_name.toString().toLowerCase().includes(term.toLowerCase()))
                        return provider;
                if (provider.email != undefined)
                    if (provider.email.toString().toLowerCase().includes(term.toLowerCase()))
                        return provider;
                if (provider.phone != undefined)
                    if (provider.phone.toString().toLowerCase().includes(term.toLowerCase()))
                        return provider;
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/providers/filter.pipe.ts